import { Paper, Stack } from '@mantine/core';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import StatsControls from './metrics/StatsControls';
import { StatisticContext } from '../context/ContextWrapper';
import StatsResources from './metrics/StatsResources';
import StatsVerticalBarChart from './metrics/StatsVerticalBarChart';

function Home() {
  const { t } = useTranslation();
  const ctxStatistic = useContext(StatisticContext);

  const dataSection = {
    labels: ctxStatistic.entities[0]?.section.name_list,
    datasets: [
      {
        label: t('StatsControlsBarchart.Employee'),
        data: ctxStatistic.entities[0]?.section.employee_count_list,
        backgroundColor: '#ae3ec9',
      },
    ],
  };

  return (
    <Paper style={{ background: 'none' }}>
      <Stack>
        <StatsControls />
        <StatsVerticalBarChart
          description={t('StatisticsHelp.EmployeeNumber')}
          editingDescription={t('StatisticsHelp.EmployeeNumberEditing')}
          title={
            t('StatsControlsBarchart.Employee') +
            ': ' +
            ctxStatistic.entities[0]?.section.employee_count
          }
          data={dataSection}
          stacked={false}
        />
        <StatsResources />
      </Stack>
    </Paper>
  );
}

export default Home;
